<template>


    <Transition name="modal-fade">
      <div v-if="isdisplay" class="cf-overlay" @click.self="close">
        <Transition name="modal-slide">
          <div v-if="isdisplay" class="cf-dialog cf-dialog--md">

                <!-- Header -->
                <div class="cf-modal-head cf-dialog-head">
                    <div class="cf-modal-head__main">
                        <span class="cf-modal-head__icon"><i class="ri-store-2-line"></i></span>
                        <div>
                            <h4 class="cf-dialog-title">{{titlemodal}}</h4>
                            <p class="cf-modal-head__sub">Magasin — informations de base</p>
                        </div>
                    </div>
                    <button @click="close" type="button" class="cf-dialog-close" aria-label="Fermer"><i class="ri-close-line"></i></button>
                </div>

                <!-- Body -->
                <div class="cf-dialog-body">

                    <div class="box-body">
                        <div class="mag-tabs-nav">
                            <nav class="flex flex-wrap" aria-label="Tabs">
                                <button type="button" class="mag-tab hs-tab-active:text-primary active"
                                        id="hs-tab-js-behavior-item-1" data-hs-tab="#hs-tab-js-behavior-1" aria-controls="hs-tab-js-behavior-1">
                                    <i class="ri-information-line"></i> Information de base
                                </button>



                            </nav>
                        </div>

                        <div class="">
                            <div id="hs-tab-js-behavior-1" role="tabpanel" aria-labelledby="hs-tab-js-behavior-item-1" class="">


                                <div v-if="messagesucces!==''" class="mt-4 mb-4 alert alert-success !border-success/10 flex items-center" role="alert">

                                    <div>
                                       {{messagesucces}}
                                    </div>
                                </div>

                                <div v-if="messageerror!==''" class="mt-4 mb-4 alert alert-danger !border-danger/10 flex items-center" role="alert">

                                    <div>
                                       {{messageerror}}
                                    </div>
                                </div>


                                <div class="ti-custom-validation mt-5" >
                                    <div class="grid lg:grid-cols-1 gap-6">

                                        <!--div class="space-y-2">
                                            <label class="ti-form-label dark:text-defaulttextcolor/70 mb-0">Référence</label>
                                            <input v-model="Items.reference" type="text" class="firstName my-auto ti-form-input
                                             rounded-sm" placeholder="référence"   required>
                                            <span class="firstNameError text-red-500 text-xs hidden">error</span>
                                        </div-->

                                        <div class="space-y-2">
                                            <label class="fa2-label"><span class="fa2-req">*</span> Magasin</label>
                                            <div class="relative">
                                                <i class="ri-store-2-line fa2-field-icon"></i>
                                                <input v-model="Items.intitule" type="text" class="firstName fa2-inp pl-9" placeholder="magasin"   required>
                                            </div>
                                            <span class="firstNameError fa2-err hidden">error</span>
                                        </div>

                                        <div class="space-y-2">
                                            <label class="fa2-label"><span class="fa2-req">*</span> Zone</label>
                                            <div class="relative">
                                                <i class="ri-map-pin-line fa2-field-icon"></i>
                                                <input v-model="Items.zone" type="text" class="firstName fa2-inp pl-9" placeholder="zone"   required>
                                            </div>
                                            <span class="firstNameError fa2-err hidden">error</span>
                                        </div>



                                    </div>



                                </div>
                            </div>



                        </div>
                    </div>



                </div>
                <!-- Footer -->
                <div class="cf-dialog-foot">
                    <button @click="close" type="button" class="ti-btn ti-btn-secondary-full">Fermer</button>
                    <button v-if="typeaction==='add'"  class="ti-btn ti-btn-primary-full" @click="saveItems">
                       Enregistrer
                    </button>
                    <button v-if="typeaction==='update'" class="ti-btn ti-btn-primary-full" @click="updateItems">
                       Modifier
                    </button>
                </div>

          </div>
        </Transition>
      </div>
    </Transition>


</template>

<script>
    import templatesite from "@/components/template/apptemplate";
    import appheader from "@/components/template/appheader";
    import appsidebar from "@/components/template/appsidebar";
    import appmenu from "@/components/views/pages/definition/menu";
   // import allfunction from "@/allfunction";
    import {randomString} from "@/allfunction";
    import * as JwtService from "@/common/jwt.service";
    const axios =require('axios');

    export default {
        /* eslint-disable */
        name: "modalform",
        watch: {


        },

        computed:{




        },
        components: {
            templatesite,
            appheader,
            appsidebar,
            appmenu,

        },

        data() {
            return {
                isdisplay:false,
                messageerror:"",
                messagesucces:"",
                titlemodal:"",
                typedoc:"",
                typeaction:"add",
                Items: {pid:'',intitule:'',reference:'',zone:''},
            };
        },
        methods: {

            close(){

                this.isdisplay=false;

                this.$emit('closed');

            },

            show(titlemodal,typeaction,Items){

                this.titlemodal=titlemodal
                this.typeaction=typeaction
                //this.typedoc=typedoc
                this.Items=Items
                this.messagesucces="";
                this.messageerror="";

                this.isdisplay=true;

            },

              async  saveItems(){

                    this.$store.dispatch('lancerchargement',true)

                    if (this.Items.intitule==="" ){

                        toastr['error']( 'Veuillez saisir le nom du magasin',"<b></b>");
                        this.$store.dispatch('lancerchargement',false)
                        return

                    }

                    if (this.Items.zone==="" ){

                        toastr['error']( 'Veuillez saisir la localisation du magasin',"<b></b>");
                        this.$store.dispatch('lancerchargement',false)
                        return

                    }


                  const t = this;
                  let url=process.env.VUE_APP_API_URL+'/egl745874pdefinition771714dfe/mag/add/'+this.$store.state.appsociete+'/'+randomString();
                  let response =   axios  .post(url,this.Items,{
                      headers: {
                          'X-Requested-With': 'XMLHttpRequest',
                          'Accept': 'application/json',
                          'Content-Type': 'application/json',
                          'Authorization': 'Bearer ' + JwtService.getToken(),
                          'csrftoken': this.$store.state.appsociete
                      } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                  })

                  let res= await response
                        .then(function (res){
                           // t.$store.dispatch('beartoken',res.data.beartoken)
                            t.$store.dispatch('lancerchargement',false)
                            if(res.data.success){

                                t.messagesucces="";
                                t.messageerror="";


                                t.Items.zone="";
                                t.Items.intitule="";

                                t.messagesucces=res.data.message;

                                toastr['success']( t.messagesucces,"<b></b>");

                            }
                    else{

                               let errormessage="";

                                t.messageerror="";
                                t.messagesucces="";
                                if (res.data.datamessage.length>0){

                                    for (let message of res.data.datamessage){

                                        if (errormessage===""){

                                            errormessage=message;

                                        }else{

                                            errormessage+=" , "+message;

                                        }


                                    }


                                    t.messageerror=errormessage;

                                }
                                else{
                                    t.messageerror=res.data.message
                                }


                                toastr['error'](t.messageerror,"<b></b>");
                            }


                        })
                        .catch(

                            error => toastr['error']( "Une erreur est subvenue. <br/> veuillez contacter votre administrateur.",
                                "<b>Erreur</b>")
                        )
                        .finally(() => this.$store.dispatch('lancerchargement',false))


                },


              async  updateItems(){

                    this.$store.dispatch('lancerchargement',true)

                  if (this.Items.intitule==="" ){

                      toastr['error']( 'Veuillez saisir le nom du magasin',"<b></b>");
                      this.$store.dispatch('lancerchargement',false)
                      return

                  }

                  if (this.Items.zone==="" ){

                      toastr['error']( 'Veuillez saisir la localisation du magasin',"<b></b>");
                      this.$store.dispatch('lancerchargement',false)
                      return

                  }

                  const t = this;
                  let url=process.env.VUE_APP_API_URL+'/egl745874pdefinition771714dfe/mag/maj/'+this.$store.state.appsociete+'/'+randomString();
                  let response =   axios  .post(url,this.Items,{
                      headers: {
                          'X-Requested-With': 'XMLHttpRequest',
                          'Accept': 'application/json',
                          'Content-Type': 'application/json',
                          'Authorization': 'Bearer ' + JwtService.getToken(),
                          'csrftoken': this.$store.state.appsociete
                      } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                  })

                  let res= await response
                        .then(function (res){
                           // t.$store.dispatch('beartoken',res.data.beartoken)
                            t.$store.dispatch('lancerchargement',false)
                            if(res.data.success){

                                t.messagesucces="";
                                t.messageerror="";

                                t.messagesucces=res.data.message;

                                toastr['success']( t.messagesucces,"<b></b>");


                                t.close()

                            }
                            else{

                               let errormessage="";

                                t.messageerror="";
                                t.messagesucces="";
                                if (res.data.datamessage.length>0){

                                    for (let message of res.data.datamessage){

                                        if (errormessage===""){

                                            errormessage=message;

                                        }else{

                                            errormessage+=" , "+message;

                                        }


                                    }


                                    t.messageerror=errormessage;

                                }
                                else{
                                    t.messageerror=res.data.message
                                }


                                toastr['error'](t.messageerror,"<b></b>");
                            }


                        })
                        .catch(

                            error => toastr['error']( "Une erreur est subvenue. <br/> veuillez contacter votre administrateur.",
                                "<b>Erreur</b>")
                        )
                        .finally(() => this.$store.dispatch('lancerchargement',false))


                },


        },
        mounted() {

            // this.loaddata();
        }




    }
</script>

<style scoped>
/* Charte cf-/ds- : tokens uniquement (light-only) */
.cf-overlay { position:fixed; inset:0; z-index:1000; display:flex; align-items:center; justify-content:center; padding:1rem; background:rgb(15 23 42 / 0.45); }
.cf-dialog { width:100%; background:#fff; border-radius:var(--cf-radius); box-shadow:var(--cf-shadow-md); display:flex; flex-direction:column; max-height:90vh; overflow:hidden; }
.cf-dialog--md { max-width:560px; }
.cf-dialog-head { display:flex; align-items:center; justify-content:space-between; padding:1rem 1.25rem; border-bottom:1px solid var(--cf-border); flex-shrink:0; }
.cf-dialog-title { margin:0; font-size:0.95rem; font-weight:700; color:var(--cf-ink-strong); }
.cf-dialog-close { height:2rem; width:2rem; flex-shrink:0; display:inline-flex; align-items:center; justify-content:center; border-radius:var(--cf-radius-sm); border:none; background:var(--cf-surface-alt); color:var(--cf-muted); cursor:pointer; transition:all .15s; }
.cf-dialog-close:hover { background:#fee2e2; color:rgb(var(--danger)); }
.cf-dialog-body { padding:1.1rem 1.25rem; overflow-y:auto; flex:1; }
.cf-dialog-foot { display:flex; align-items:center; justify-content:flex-end; gap:0.6rem; padding:0.9rem 1.25rem; border-top:1px solid var(--cf-border); background:var(--cf-surface); flex-shrink:0; }

/* Onglet Preline restylé fa2-tab (souligné violet actif) — mécanique data-hs-tab inchangée */
.mag-tabs-nav { border-bottom:1px solid var(--cf-border); }
.mag-tab { position:relative; display:inline-flex; align-items:center; gap:6px; padding:10px 16px; margin-bottom:-1px;
  font-size:0.82rem; font-weight:600; border:none; border-bottom:2px solid transparent; background:none;
  cursor:pointer; transition:all .15s; white-space:nowrap; color:var(--cf-muted); }
.mag-tab:hover { color:var(--cf-ink); background:rgb(var(--primary)/0.06); }
.mag-tab.active { color:rgb(var(--primary)); border-bottom-color:rgb(var(--primary)); background:rgb(var(--primary)/0.08); }

/* Champs charte (cf. fa2-*) */
.fa2-inp { width:100%; height:40px; padding:0 12px; border-radius:0.25rem;
  border:1px solid rgb(var(--input-border,203 213 225)); background:#fff;
  color:var(--cf-ink); font-size:0.82rem; outline:none;
  transition:border-color .2s, box-shadow .2s; }
.fa2-inp:focus { border-color:rgb(var(--primary)); box-shadow:0 0 0 3px rgb(var(--primary)/0.10); }
.fa2-label { font-size:0.72rem; text-transform:uppercase; letter-spacing:0.03em;
  font-weight:600; color:var(--cf-muted); display:flex; align-items:center; gap:4px; }
.fa2-req { color:rgb(var(--danger)); }
.fa2-field-icon { position:absolute; top:50%; transform:translateY(-50%); left:0;
  padding-left:12px; display:flex; align-items:center; pointer-events:none;
  color:var(--cf-faint); font-size:1rem; z-index:1; }
.fa2-err { font-size:0.72rem; color:rgb(var(--danger)); margin-top:2px; }

.modal-fade-enter-active, .modal-fade-leave-active { transition:opacity 0.25s ease; }
.modal-fade-enter-from, .modal-fade-leave-to { opacity:0; }
.modal-slide-enter-active, .modal-slide-leave-active { transition:all 0.25s ease; }
.modal-slide-enter-from, .modal-slide-leave-to { opacity:0; transform:translateY(-16px); }

@media (max-width:768px) { .cf-dialog--md { max-width:100%; } }
</style>
